import Vue from 'vue'
import Vuex from 'vuex'
import RPC from '../mixins/RPC'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        init_state: "created",
        user: null,
        context: {
            entity_id: 0,
            host_id  : 0,
            race_id  : 0
        },
        data: {
        },
        menu_lu: {},
        menu_parent_lu: {},
        error: {
            show: false,
            msg: "?"
        },
        loading: {
            show: false,
            msg: "?"
        },
        drawer_show: false
    },
    mutations: {
        setUser (state, payload) {
            state.user = payload
            if (state.user === null) {
                //this.commit('setCompanies', [])
            } else {
                this.dispatch('getData')
            }
        },
        setLoading (state, payload) {
            state.loading.show = payload.show
            state.loading.msg = payload.msg
        },
        showError (state, error) {
	    console.log(error)
	    state.error.msg = (error.result !== undefined) ? error.result : error.toString()
	    state.error.show = true
	},
        setError (state, payload) {
            state.error.show = payload.show
            state.error.msg = payload.msg
        },
        setMenuChoice: (state, payload) => {
            state.context[payload.which + "_id"] = payload.value
            localStorage.setItem('context', JSON.stringify(state.context))
        },
        setMenuChoiceFirst: (state, name) => {
            if(name === 'entity') {
                if(state.context.entity_id === 0 && state.data.entities.length > 0) {
                    state.context.entity_id = state.data.entities[0].id
                }
            } else if(name === 'host') {
                let hosts = state.data.hosts.filter(h => h.entity.id === state.context.entity_id)
                if(hosts.length === 0) {
                    state.context.host_id = 0
                } else {
                    state.context.host_id = hosts[0].id
                }
            } else if(name === 'race') {
                let races = state.data.races.filter(r => r.host.id === state.context.host_id)
                if(races.length === 0) {
                    state.context.race_id = 0
                } else {
                    var race = races.find(r => r.series.current == r.id)
                    if(race === undefined) {
                        state.context.race_id = races[0].id
                    } else {
                        state.context.race_id = race.id
                    }
                }
            }
            localStorage.setItem('context', JSON.stringify(state.context))
        },
        setInitState(state, init_state) {
            state.init_state = init_state
        },
        setData(state, data) {
            state.data = data
            state.menu_lu = {}
	    state.menu_parent_lu = {}
            for(var k in state.data.menus) {
                var items = state.data.menus[k]
                for(var j in items) {
                    if(items[j].url !== undefined) {
                        state.menu_lu[items[j].url] = k
                    }
		    if(items[j].child !== undefined) {
			state.menu_parent_lu[items[j].child] = k
		    }
                }
            }
            var urlParams = new URLSearchParams(window.location.search);
            var cache = localStorage.getItem('context')
	    var context = { entity_id: 0, host_id: 0, race_id: 0 }
	    if(cache !== null) {
                Object.assign(context, JSON.parse(cache))
	    }
            if(urlParams.has("_entity")) {
		context.entity_id = parseInt(urlParams.get('_entity'))
            }
            if(context.entity_id === 0 && state.data.entities.length > 0) {
                context.entity_id = state.data.entities[0].id
            }
	    let hosts = state.data.hosts.filter(h => h.entity_id === context.entity_id)
	    if(context.host_id === 0 || hosts.find(h => h.id === context.host_id)===undefined) {
		if(hosts.length === 0) {
                    context.host_id = 0
		} else {
                    context.host_id = hosts[0].id
		}
	    }
	    let races = state.data.races.filter(r => r.host_id === context.host_id)
	    if(context.race_id === 0 || races.find(r => r.id === context.race_id)===undefined) {
		if(races.length === 0) {
                    context.race_id = 0
		} else {
                    var race = races.find(r => r.series.current == r.id)
                    if(race === undefined) {
			context.race_id = races[0].id
                    } else {
			context.race_id = race.id
                    }
		}
	    }
            Object.assign(state.context, context)
            localStorage.setItem('context', JSON.stringify(state.context))
	    this.dispatch("setInitState", "ready")
        },
        showDrawer(state, payload) {
            if(state.drawer_show !== payload) {
                state.drawer_show = payload
            }
        },
	setInitState(state, newstate) {
            state.init_state = newstate
	},
        
    },
    actions: {
	print ({commit}, node) {
	    const printNode = document.getElementById("print_node");
	    while (printNode.firstChild) {
		printNode.removeChild(printNode.lastChild);
	    }
	    document.getElementById("print_node").appendChild(node)
	    window.print()
	},
        logout ({commit}) {
            RPC.methods.rpc("rest","User","logout",{}, "Logging Out")
                .then(function (data) {
                    commit('setInitState', 'notLoggedIn')
                })
                .catch(function (error) {
                    commit('showError', error)
                })
        },
        userWhoAmI ({commit}) {
            RPC.methods.rpc('rest', 'User', 'whoami', {}, "Checking Login")
                .then(function (data) {
                    commit('setUser', data)
                })
                .catch(function (error) {
                    console.log(error)
                    commit('setUser', null)
                    if(error.result === "Not Logged In") {
                        commit('setInitState', 'notLoggedIn')
                        //router.push("/login")
                    } else {
                        commit('setInitState', 'error')
                        commit('showError', error)
                    }
                })
        },
        getData({commit}) {
            RPC.methods.rpc('backend', 'Backend', 'data', {}, "Fetching Data")
                .then(function (data) {
                    commit('setData', data)
                })
                .catch(function (error) {
                    commit('setInitState', 'error')
                    commit('showError', error)
                })
            
        },
	setInitState({commit, state}, newstate) {
	    commit('setInitState', newstate)
	},
    },
    getters: {
        entity: state => {
            if(state.data.entities === undefined || state.context.entity_id === 0 || state.context.entity_id === null) {
                return {
                    name: "???",
                    id: 0
                }
            } else {
                return state.data.entities.find(e => e.id == state.context.entity_id)
            }
        },
        host: state => {
            if(state.data.hosts === undefined || state.context.host_id === 0 || state.context.host_id === null) {
                return {
                    name: "???",
                    id: 0
                }
            } else {
		var h = state.data.hosts.find(e => e.id == state.context.host_id)
		if(h===undefined) {
		    return { name: "??", id: 0 }
		}
		return h
            }
        },
        hosts: state => {
            if(state.data.hosts === undefined)
                return []
            return state.data.hosts.filter(h => h.entity.id === state.context.entity_id)
        },
        race: state => {
            if(state.data.races === undefined || state.context.race_id === 0) {
                return {
                    name: "???",
                    id: 0
                }
            } else {
                var r= state.data.races.find(e => e.id == state.context.race_id)
		if(r === undefined){
		    return { name: "??", id: 0}
		}
		return r
            }
        },
        menu_heir: (state) => (router) => {
            let url = router.path
            if(url === "") {
                url="/"
            }
            return state.menu_lu[url]
        },
        menu_parent_item: (state, getters) => (router) => {
	    var heir = getters.menu_heir(router)
	    var parent = state.menu_parent_lu[heir]
	    if(parent === undefined) {
		return undefined
	    }
	    return state.data.menus[parent][0]
        },
        menu_url: (state, getters) => (item) => {
            if(item.url !== undefined) {
                return item.url
            }
            if(item.child !== undefined) {
                return getters.menu_url(state.data.menus[item.child][0])
            }
            return ""
        },
	menu_check_perm: (state, getters) => (perms) => {
	    if(perms === null || perms === undefined) {
		return true
	    }
	    for(var idx in perms) {
		if(getters.entity.perms !== undefined && getters.entity.perms[perms[idx]]) {
		    return true
		}
	    }
	    return false
	},
	amt_to_raw: (state, getters) => (amt, currency) => {
	    if(currency === "USD" || currency === "CAD") {
		return Math.round(amt*100);
	    } else if(currency === "JPY") {
		return Math.round(amt);
	    } else {
		return "???"
	    }
	},
	raw_to_amt: (state, getters) => (amt, currency) => {
	    if(amt === undefined || amt == null) {
		return 0
	    }
	    if(currency === "USD" || currency === "CAD") {
		var x = amt + ""
                var negative = (x<0)
                var sign = ""
                if(negative) {
                    x = x.substring(1)
                    sign = "-"
                    amt = -amt
                }
                if(amt == 0) {
                    return "0.00"
                } else if(amt < 10) {
                    return sign + "0.0" + x
                } else if(amt < 100) {
                    return sign + "0." + x
                } else {
                    return sign + x.slice(0, x.length-2) + "." + x.slice(x.length-2)
                }
                
	    } else if(currency === "JPY") {
		return amt;
	    } else {
		return "???"
	    }
	},
	fmt_from_raw: (state, getters) => (amt, currency, show_currency, show_symbol, add_commas) => {
            if(show_currency === undefined) {
                show_currency = true
            }
            if(show_symbol === undefined) {
                show_symbol = true
            }
	    var x;
	    if(currency === "USD" || currency === "CAD") {
		x = (show_symbol ? "$" : "") + getters.raw_to_amt(amt, currency) + " " + (show_currency ? currency : "")
	    } else if(currency === "JPY") {
		x = (show_symbol ? "¥" : "") + getters.raw_to_amt(amt, currency) + " " + (show_currency ? currency : "")
	    } else {
		return "Unknown currency " + currency
	    }
	    if(add_commas) {
		return x.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
	    } else {
		return x
	    }
	},

        
    },
    modules: {
    }
})
